/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MessageInfoTypeDto = {
    Info: 'Info',
    Warning: 'Warning',
    Error: 'Error'
} as const;
export type MessageInfoTypeDto = typeof MessageInfoTypeDto[keyof typeof MessageInfoTypeDto];


export function MessageInfoTypeDtoFromJSON(json: any): MessageInfoTypeDto {
    return MessageInfoTypeDtoFromJSONTyped(json, false);
}

export function MessageInfoTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageInfoTypeDto {
    return json as MessageInfoTypeDto;
}

export function MessageInfoTypeDtoToJSON(value?: MessageInfoTypeDto | null): any {
    return value as any;
}

/**
 * Check if a given object implements the MessageInfoTypeDto interface.
 */
 export function instanceOfMessageInfoTypeDto(value: any): value is MessageInfoTypeDto {
    return Object.values(MessageInfoTypeDto).includes(value)
}

